import React from 'react';

import {Group, Item} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';

import {fileInputDropZoneIcon} from './file-input.module.styl';

type Props = {
    addedFile: File | null,
    description: string,
    acceptedFormats: string[],
};

export const DropZoneView = ({addedFile, acceptedFormats, description}: Props) => {

    if (addedFile) {
        return (
            <div style={{width: 900}}>
                <Group direction="v" gap="s">
                    <Icon className={fileInputDropZoneIcon} type={Icons.CHECK_CIRCLE}/>
                    <Item>Completed</Item>
                </Group>
            </div>
        );
    }
    return (
        <div style={{width: 900}}>
            <Group direction="v" gap="xxs">
                <Icon className={fileInputDropZoneIcon} type={Icons.UPLOAD}/>
                <span>Drag & drop a file to upload or <a>browse</a></span>
                <span className="font-size font-size_footer">
                    {description}
                    <br/>
                    Accepted formats: {acceptedFormats}
                </span>
            </Group>
        </div>

    );
};
